import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { captureCallFlagsFromUrl, captureUserKeyFromUrl, getUserKey, rememberUserKey, restoreUserKey } from "./lib/storage";
import "./styles/global.css";

captureUserKeyFromUrl();
const callFlags = captureCallFlagsFromUrl();
// A browser that lost its stored key (cleared, or Safari's week) gets it back
// from its cookie before the first render; one that has it refreshes the
// cookie. Neither blocks for more than two seconds.
const keyReady = getUserKey() ? Promise.resolve(rememberUserKey()) : restoreUserKey();

// --accent is applied at runtime from App.tsx, not here: the accent is a
// per-device preference read from settingsStore.ts, not a fixed default, and
// --accent-contrast is a fixed token in tokens.css (#ffffff, every accent hue
// is dark enough for white text). See tokens.css's file comment.

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("No #root element in index.html.");
}

void keyReady.then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App joinNow={callFlags.go} moveNow={callFlags.move} />
    </StrictMode>,
  );
});
